export default __webpack_public_path__ + "static/media/setion07_kv01_m.88673f63.png";